import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/layout';
import Seo from '../components/seo';
import '../styles/styles.sass';
import useLanguage from '../hooks/useLanguage';

import {
  HomeAbout,
  HomeAdvantages,
  HomeMainScreen,
  HomeServices,
  HomeSteps,
  Ticker,
  Video,
  DownloadPdf,
  HomeReviews,
  HomeFreeLesson,
} from '../components/Pages/Home';

import { homeData } from '../db/homeData';
import { homeStatic } from '../db/homeStatic';
import { contactsData } from '../db/contactsData';
import { ServicesPackages } from '../components/Pages/Services';
import HomePackages from '../components/Pages/Home/HomePackeges/HomePackages';

const IndexPage = ({ data }) => {
  const homeDatas = data.strapiHome;
  const langToggle = useLanguage;

  console.log(data);

  return (
    <Layout>
      <Seo
        title={langToggle(homeDatas.seo_title_ua, homeDatas.seo_title_ru)}
        description={langToggle(
          homeDatas.seo_description_ua,
          homeDatas.seo_description_ru
        )}
        keywords={[
          langToggle(homeDatas.seo_keywords_ua, homeDatas.seo_keywords_ru),
        ]}
      />
      <HomeMainScreen
        mainData={homeDatas.home_main}
        mainStatic={homeStatic.main_scroll}
        mainSocials={contactsData.socials}
        freeLessonData={homeDatas.home_free_lesson}
      />

      <Ticker tickerData={homeDatas.home_services.ticker} />
      {/* <HomeServices servicesData={homeDatas.home_services.Services} /> */}
      <HomePackages />
      <ServicesPackages
        packagesData={data.strapiServices.services_packages}
        promoData={data.strapiPromocode.promocode}
      />
      <Video videoData={homeDatas.home_video} />

      <HomeAbout
        aboutData={homeDatas.home_about}
        freeLesson={homeData.home_free_lesson}
      />
      <Ticker tickerData={homeDatas.home_about.ticker} />
      <HomeAdvantages advantagesData={homeDatas.home_advantages} />
      <HomeSteps stepsData={homeDatas.home_steps} />
      <DownloadPdf downloadPdfData={homeDatas.home_guides} />
      <HomeReviews reviewsData={homeDatas.home_reviews} />
      <HomeFreeLesson freeLessonData={homeDatas.home_free_lesson} />
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query MainHome($language: String!) {
    strapiHome {
      seo_title_ru
      seo_title_ua
      seo_description_ru
      seo_description_ua
      seo_keywords_ru
      seo_keywords_ua
      home_main {
        title_01_ru
        title_01_ua
        title_02_ru
        title_02_ua
        title_03_ru
        title_03_ua
      }
      home_video {
        video_ua
        video_ru
        cover {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
            }
          }
        }
      }

      home_services {
        ticker {
          id
          ticker_ua
          ticker_ru
        }
        Services {
          title_ua
          title_ru
          description_ua
          description_ru
          link
        }
      }

      home_about {
        ticker {
          id
          ticker_ua
          ticker_ru
        }
        title_ua
        title_ru
        description_ua
        description_ru
      }

      home_advantages {
        title_ua
        title_ru
        description_ua
        description_ru
      }
      home_steps {
        title_ua
        title_ru
        step_count
        Steps_Items {
          marker_ua
          marker_ru
          title_ua
          title_ru
        }
      }

      home_guides {
        marker_ua
        marker_ru
        title_ua
        title_ru
        # pdf_ru {
        #   url
        # }
        pdf_ua {
          url
        }
      }

      home_reviews {
        title_ua
        title_ru
        image {
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 1400
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }

      home_free_lesson {
        title_ua
        title_ru
      }
    }

    strapiPromocode {
      promocode {
        promocode
      }
    }

    strapiServices {
      services_packages {
        Titles {
          title_ua
          title_ru
          sub_title_ua
          sub_title_ru
        }
        Packages {
          duration_ua
          duration_ru
          rate_ua
          rate_ru
          number_lessons
          price_rub
          price_uah
          price_usd
          price_eur
          sale_uah
          sale_rub
          sale_usd
          sale_eur
        }
      }
    }
    strapiPromocode {
      promocode {
        promocode
      }
    }

    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
